import axios from "axios";
import {apiURL,makeFormData} from "src/utilities/utilityFunctions";
import {appSettingModel} from "src/datamodels/foundation";
import store from 'src/store';
import {obtainUser} from "src/containers/permissions/permissionFunctions";

export const submitNewUser = (person,callback,fail) => {
    axios.post(apiURL() + "/gameTime/newUser",makeFormData({...person.personData})).then((evt)=>{
        callback(evt);
    }).catch((evt)=>{
        fail(evt)
    })
};

export const createNewAccount = (person,callBack,fail) => {
    //eslint-disable-next-line
    axios.post(apiURL() + "/users/account/new",makeFormData(person),{headers: {
            "DomainCode":appSettingModel().domainCode
        }}).then((evt)=>callBack(evt)).catch((evt)=>fail(evt));
};

export const obtainAccountDetailsByPerson = (personid,callback,fail) => {
    let acct = personid ? personid : store.getState().user.personuuid;
    axios.get(apiURL() + "/users/account/person/" + acct,{headers: {
            "Authorization": "Bearer " + obtainUser(),
            "DomainCode":appSettingModel().domainCode
        }}).then((evt)=>{
        callback(evt);
    }).catch((evt)=>{
        fail(evt)
    })
};

export const obtainAccountDetails = (accountid,callback,fail) => {
    let acct = accountid ? accountid : store.getState().user.account.accountuuid;
    axios.get(apiURL() + "/users/account/" + acct,{headers: {
            "Authorization": "Bearer " + obtainUser(),
            "DomainCode":appSettingModel().domainCode
        }}).then((evt)=>{
        callback(evt);
    }).catch((evt)=>{
        fail(evt)
    })
};
